import tips from '@/common/tips'
import tool from '@/common/tool'
import axios from '@/common/axios'
import urls from '@/common/urls'
import oss from '@/common/oss'

const globalSize = 200;
const recorder = {
  stream:null,
  oss_info:null,
  chunks:[],
  blobSize:0,
  recorder:null,
  callback:null,
  meetId:0,
  page:0,
  isCanRecorder:false,
  voiceLength:0,
  isAutoStart:false,
// ==============================================
// 核心优化：**低负载、稳定、不卡顿** 的编码配置
// ==============================================
  recorderOptions:{
    mimeType: 'video/webm;codecs=vp8,opus', // 最稳！所有浏览器不卡
    // mimeType: 'video/mp4;codecs=h264,aac', // 可选，但部分手机长录制会卡
    videoBitsPerSecond: 1200000, // 1.2Mbps 手机/浏览器最稳
    audioBitsPerSecond: 128000,
  },
// 摄像头配置（关键：不设置过高就不会越录越卡）
  camera:{
    video: {
      width: { ideal: globalSize },
      height: { ideal: globalSize },
      frameRate: { ideal: 20, max: 24 }, // 20帧最稳！不发热
      facingMode: 'user'
    },
    audio: true
    // audio: {
    //   noiseSuppression: true, // 降噪
    //   echoCancellation: true // 回音消除
    // },
    // video : {
    //   height:globalSize,
    //   width:globalSize,
    //   facingMode: "user" // 前置摄像头
    // }
  },
  sourceType:{type:"video/webm"},
  initRecorder: async () => {
    if(!recorder.stream) return;
    // 标清 < 0.8 高清 > 0.8 超清>1.5 蓝光 2.5M
    recorder.recorder = new MediaRecorder(recorder.stream,recorder.recorderOptions);
    recorder.recorder.ondataavailable = async (e) => {
      recorder.chunks.push(e.data);
    }
  },
  startRecord: async (meetId= 0,page=0) => {
    if(meetId){
      recorder.meetId =  meetId
    }
    recorder.page =  page + 1
    recorder.chunks = []
    return new Promise((resolve)=>{
      if(!recorder.isCanRecorder){
        resolve({status:500,data:{}})
        return;
      }
      if(!recorder.recorder){
        setTimeout(()=>{
          recorder.initRecorder()
          // ==========================================
          // 每 500ms 存一次数据
          // ==========================================
          recorder.recorder &&  recorder.recorder.start(500)
          resolve({status:200,data:{}})
        },500)
        return;
      }
      if(recorder.recorder.state == "recording"){
        recorder.recorder.onstop = async ()=>{
          recorder.chunks = []
          recorder.recorder.start()
          resolve({status:200,data:{}})
        }
        recorder.recorder.stop()
        return;
      }
      recorder.recorder.start()
      resolve({status:200,data:{}})
    })
  },
  stopRecord: async (voiceLength,callback) => {
    recorder.voiceLength = voiceLength
    recorder.callback = () => {}
    return new Promise((resolve)=>{
      // 录制结束执行
      recorder.recorder.onstop = async (e)=>{
        let blob = new Blob(recorder.chunks,recorder.sourceType)
        recorder.blobSize = blob.size;
        callback&&callback(blob.size)
        let data = await recorder.uploadVoice()
        if(!data){
          resolve({status:500,data:{}})
        }else{
          resolve({status:200,data:{
            localId:data,
            serverId:data,
            videoBlob:blob,
          }})
        }
      }
      try{
        if(recorder.recorder.state == "recording"){
          recorder.recorder.stop()
        }else{
          recorder.recorder.onstop = () => {}
          recorder.recorder.stop()
          resolve({status:500,data:{}})
        }
      }catch(err)
      {
        resolve({status:500,data:{}})
      }
    })
  },
  getVideoName(){
    let fileName = `meet_video_${recorder.meetId}-${recorder.page || Math.random()}-${Date.now()}`
    if(!recorder.meetId){
      fileName =  `meet_video_${Math.random()}_${Date.now()}`
    }
    return `kclass/${recorder.meetId}/${fileName}.mp4`
  },
  upload:async (data)=>{
    return new Promise(resolve=>{
      resolve({status:200,data:{
        ...data,
        page:recorder.page ? recorder.page- 1 : 0
      }})
    })
  },
  async post(){
    return new Promise(resolve=>{
      setTimeout(async ()=>{
        let blob = new Blob(recorder.chunks,recorder.sourceType);
        try{
          let data = await oss.upload({
            file:blob,
            fileName:recorder.getVideoName(),
            meetId:recorder.meetId
          },recorder.oss_info)
          resolve(data.url)
        }catch(err){
          resolve("")
        }
      },500)
    })
  },
  uploadVoice: async () => {
    return new Promise(async (resolve)=>{
      try{
        if(!recorder.chunks[0] || recorder.chunks[0].size < 5*1000){
          resolve("")
          return
        }
      }catch(err){
        resolve("")
        return;
      }
      let url = await recorder.post()
      recorder.chunks = []
      resolve(url)
    })
  },
  playVoice(url){
  },
  stopVoice(url){
  },

  mediaSuccess: async (stream) => {
    recorder.stream = stream;
    recorder.initRecorder()
  },
  mediaError: async (error) => {
    let content = `访问用户媒体设备失败${error.name}, ${error.message}`
    tips.error({text:content})
  },
  init: async (wx,oss_info,callback) => {
    if(tool.getIOSVersion()){
      recorder.sourceType = {type:"video/mp4"}
    }
    recorder.oss_info = oss_info;
    let mediaSuccess = (stream)=>{
      const track = stream.getVideoTracks()[0];
      track.applyConstraints({width:{min:globalSize,max:globalSize},height:{min:globalSize,max:globalSize}}).then(()=>{
        recorder.mediaSuccess(stream)
        recorder.isCanRecorder = true
        callback(stream)
      })
    }
    let mediaError = (error)=>{
      recorder.mediaError(error)
      callback("")
    }
    if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
      navigator.mediaDevices.getUserMedia(recorder.camera).then(mediaSuccess).catch(mediaError);
      return;
    }
    let execFun = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
    if(execFun){
      execFun(recorder.camera, mediaSuccess, mediaError)
    }else{
      // tips.error({text:'当前浏览器不支持访问用户媒体'});
      mediaError("当前浏览器不支持访问用户媒体")
    }
  }
}

export default recorder
